import { createBrowserRouter } from "react-router-dom";
import Home from "./pages/home";
import News from "./pages/news";
import Media from "./pages/media";
import Merchandise from "./pages/merchandise";
import Sponsors from "./pages/sponsors";
import About from "./pages/about";
import App from "./App";
import F3A_Series from "./pages/series/f3a/f3a";
import F4A_Series from "./pages/series/f4a/f4a";
import FFA_Series from "./pages/series/ffa/ffa";
import S5000_Series from "./pages/series/s5000/s5000";
import APJC_Series from "./pages/series/apjc/apjc";
import Trinations_Series from "./pages/series/trinations/trinations";
import Account from "./pages/account";
import Security from "./pages/security";
import Contact from "./pages/contact";
import FRG_Rules from "./pages/frg-rules";
import Feedback from "./pages/feedback";
import { RequireAuth } from './components/auth/RequireAuth';
import { Login } from './components/auth/Login';
import LeagueAdmin from "./pages/admin/LeagueAdmin/league-admin";
import TeamAdmin from "./pages/admin/TeamAdmin/team-admin";
import MotorsportAdmin from "./pages/admin/MotorsportAdmin/motorsport-admin";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },{
        path: "/signin",
        element: <Login />,
      },{
        path: "/news",
        element: <News />,
      },{
        path: "/media",
        element: <Media />,
      },{
        path: "/merchandise",
        element: <Merchandise />,
      },{
        path: "/sponsors",
        element: <Sponsors />,
      },{
        path: "/about",
        element: <About />,
      },{
        path: "/f3a-series",
        element: <F3A_Series />,
      },{
        path: "/f4a-series",
        element: <F4A_Series />,
      },{
        path: "/ffa-series",
        element: <FFA_Series />,
      },{
        path: "/s5000-series",
        element: <S5000_Series />,
      },{
        path: "/apjc-series",
        element: <APJC_Series />,
      },{
        path: "/trinations-series",
        element: <Trinations_Series />,
      },{
        path: "/f4a-series",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-results",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-calendar",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-rules",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-drivers",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-teams",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-livery",
        element: <F4A_Series />,
      },{
        path: "/f4a-series-stats",
        element: <F4A_Series />,
      },{
        path: "/frg-rules",
        element: <FRG_Rules />,
      },{
        path: "/contact",
        element: <Contact />,
      },{
        path: "/feedback",
        element: <Feedback />,
      },{
        path: "/account",
        element:
          <RequireAuth>,
            <Account />,
          </RequireAuth>,
      },{
        path: "/league-admin",
        element: <LeagueAdmin />,
      },{
        path: "/team-admin",
        element: <TeamAdmin />,
      },{
        path: "/motorsport-admin",
        element: <MotorsportAdmin />,
      },
    ],
  },
]);

export default router;
